export default function Marquee({ items, className = "" }) {
  const row = [...items, ...items];
  return (
    <div aria-hidden="true" className={`overflow-hidden border-y border-gold/15 py-5 ${className}`}>
      <div className="animate-marquee flex w-max items-center gap-10 pr-10">
        {row.map((item, i) => (
          <span key={i} className="flex items-center gap-10">
            <span className="whitespace-nowrap font-mono text-[11px] uppercase tracking-[0.35em] text-ivory/40">{item}</span>
            <span className="text-[8px] text-gold/60">&#9670;</span>
          </span>
        ))}
      </div>
    </div>
  );
}
